module.exports = __webpack_public_path__ + "static/media/Hero-Banner.97284111.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/photos/Hero-Banner.jpg
// module id = 218
// module chunks = 8